import { Close, Lightbulb } from '@mui/icons-material';
import { Box, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import React, { Component } from 'react';
import axios from "axios";
import Global from "../../../customlib/Global";
import Api from "../../../customlib/Api";
import HsmSelector from './HsmSelector';
import CustomerOwnerSelector from './CustomerOwnerSelector';

class FuBlastReminderTeleSetting extends Component {
    state = { 
        isDialogOpen: false,
        logs: [],
        isLoadingLog: false,
        isLoadingUpdateState: false,

        selectedOwnerIds: [],
        selectedHsm: null,

        obSetting: null
    }

    loadGeneralSettingLogs = () => {
        this.setState({isLoadingLog: true}, () => {
            axios
                .post(Api.getGeneralSettingLogs(), {fieldName: "fuReminderTeleEnabled"}, Api.getRequestHeader())
                .then((response) => {
            
                    console.log("GENERAL_SSETTINGS", response.data);
                
                    var data = response.data;
                
                    this.setState({logs: data.data, isLoadingLog: false});
            
                })
                .catch((error) => {
                    this.setState({isLoadingLog: false});
                    console.error("There was an error!", error);
                });
        });
    }

    updateFuBlastTeleState = (isEnabled) => {

        const ownerIds = [...this.state.selectedOwnerIds];

        const params = {
            enabled: isEnabled,
            ownerIds: ownerIds,
            hsm: this.state.selectedHsm
        };

        console.log("params", params);
        // return;

        this.setState({isLoadingUpdateState: true}, () => {
            axios
                .post(Api.updateFuBlastTeleReminderState(), params, Api.getRequestHeader())
                .then((response) => {
            
                    console.log("GENERAL_SSETTINGS", response.data);
                    
                    this.setState({isLoadingUpdateState: false}, () => {
                        this.props.onReload();
                        this.loadGeneralSettingLogs();
                    });
            
                })
                .catch((error) => {
                    this.setState({isLoadingUpdateState: false});
                    console.error("There was an error!", error);
                });
        });
    }

    handleUpdateSelectedHsm = (hsm) => {
        this.setState({selectedHsm: hsm}, () => {
            console.log("SELECTEDHSM", this.state.selectedHsm);
        });
    }

    handleShowDialog = () => {
        this.setState({isDialogOpen: true}, () => {
            this.loadGeneralSettingLogs();
        });
    }

    handleCloseDialog = () => {
        this.setState({isDialogOpen: false, logs: []});
    }

    handleOwnerSelectionChange = (selectedOwnerIds) => {
        this.setState({selectedOwnerIds: selectedOwnerIds});
    }

    componentDidMount() {
        // console.log("DATADATA", this.props.data);
        this.setState({obSetting: {...this.props.data?.fuReminderTeleSetting}}, () => {
            console.log("MOUNTDATA", this.state.obSetting);
        });
    }

    render() { 

        if(!Global.get().admin && !Global.isTeleAdmin()){
        // if(Global.get().admin || Global.isTeleAdmin()){
            return (
                <Paper 
                    sx={{backgroundColor: "#cccacaff", pt: "10px", pb: "10px", pl: "15px", pr: "15px"}}
                >
                    <Grid container spacing={1}>
                        <Grid item xs={10}>
                            <strong>Blast Reminder Tele</strong>
                        </Grid>
                        <Grid item xs={2}>
                            <Lightbulb color={this.props.data?.fuReminderTeleSetting?.isEnabled ? "warning" : "default"} />                                    
                        </Grid>
                    </Grid>
                </Paper> 
            );
        }

        return (
            <Box>
                <Tooltip title={`Blast Akun Tele RB (${this.props.data?.fuReminderTeleSetting?.isEnabled ? 'ON' : 'OFF'})`}>
                    <Paper 
                        sx={{backgroundColor: "#b9e4f6ff", cursor: "pointer", pt: "10px", pb: "10px", pl: "15px", pr: "15px"}}
                        onClick={this.handleShowDialog}
                    >
                        <Grid container spacing={1}>
                            <Grid item xs={10}>
                                <strong>Blast Reminder Tele</strong>
                            </Grid>
                            <Grid item xs={2}>
                                <Lightbulb color={this.props.data?.fuReminderTeleSetting?.isEnabled ? "warning" : "default"} />                                    
                            </Grid>
                        </Grid>
                    </Paper> 
                </Tooltip> 

                <Dialog
                    open={this.state.isDialogOpen}
                    onClose={this.handleCloseDialog}
                    maxWidth={"lg"}
                    fullWidth
                    
                >
                    <DialogTitle id="alert-dialog-title">
                        
                        <Grid container spacing={1}>
                            <Grid item sm={10} xs={12}>{"Blast FU Reminder Tele"}</Grid>
                            <Grid item sm={2} xs={12} textAlign={"right"}>
                                <IconButton onClick={this.handleCloseDialog} color='error'><Close /></IconButton>
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <Divider />
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {
                                this.props.data?.fuReminderTeleSetting?.isEnabled && (
                                    <Grid container spacing={1}>
                                        <Grid item sm={9} xs={12}>Blast Reminder Tele sedang <strong>Aktif</strong></Grid>
                                        <Grid item sm={3} xs={12} textAlign={"right"}>
                                            <Button 
                                                variant='contained' 
                                                color='error' 
                                                sx={{textTransform: "capitalize"}}
                                                onClick={() => this.updateFuBlastTeleState(false)}
                                                disabled={this.state.isLoadingUpdateState}
                                                fullWidth
                                            >
                                                Simpan &amp; Nonaktifkan!
                                            </Button>
                                        </Grid>
                                    </Grid>
                                )
                            }

                            {
                                !this.props.data?.fuReminderTeleSetting?.isEnabled && (
                                    <Grid container spacing={1}>
                                        <Grid item sm={9} xs={12}>Blast Reminder Tele sedang <strong>Tidak Aktif</strong></Grid>
                                        <Grid item sm={3} xs={12} textAlign={"right"}>
                                            <Button 
                                                variant='contained' 
                                                color='primary' 
                                                sx={{textTransform: "capitalize"}}
                                                onClick={() => this.updateFuBlastTeleState(true)}
                                                disabled={this.state.isLoadingUpdateState}
                                                fullWidth
                                            >
                                                Simpan &amp; Aktifkan!
                                            </Button>
                                        </Grid>
                                    </Grid>
                                )
                            }

                            <HsmSelector onUpdate={this.handleUpdateSelectedHsm} selectedHsm={this.state.selectedHsm} />

                            {/* <Divider sx={{mt: "10px", mb: "10px"}} /> */}
                            <CustomerOwnerSelector
                                customerOwnerIds={this.state.obSetting?.customerOwnerIds}
                                onSelectionChange={this.handleOwnerSelectionChange}
                            />
                        </DialogContentText>
                        <Divider sx={{mt: "10px", mb: "10px"}} />
                        <Typography variant='h6'>Riwayat Blast Reminder Tele</Typography>
                        <TableContainer>
                            <Table size='small'>
                                <TableHead>
                                    <TableCell><strong>Tag</strong></TableCell>
                                    <TableCell><strong>Action</strong></TableCell>
                                    <TableCell><strong>By</strong></TableCell>
                                    <TableCell><strong>At</strong></TableCell>
                                </TableHead>
                                <TableBody>
                                {
                                    this.state.isLoadingLog && (
                                        <TableRow>
                                            <TableCell colSpan={4} textAlign={"center"}>Loading ... <CircularProgress size={"15px"} /></TableCell>
                                        </TableRow>
                                    )
                                }
                                {
                                    !this.state.isLoadingLog && this.state.logs?.map(item => {
                                        return (
                                            <TableRow>
                                                <TableCell width={"40%"}>{item.tag}</TableCell>
                                                <TableCell width={"20%"}>
                                                    {typeof item.newValue === "boolean" &&  (item.newValue === true ? "Diaktifkan" : "Dinonaktifkan")}
                                                    {typeof item.newValue === "object" && (item.newValue.isEnabled ? "Diaktifkan" : "Dinonaktifkan")}
                                                </TableCell>
                                                <TableCell width={"20%"}>{item.executorName}</TableCell>
                                                <TableCell width={"20%"}>{Global.formatDateTimeToStrDateTime24(item.created_at)}</TableCell>
                                            </TableRow>
                                        );
                                    })
                                }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContent>
                    <DialogActions>
                        {/* <Button onClick={()=>{}}>Disagree</Button>
                        <Button onClick={()=>{}} autoFocus>
                            Agree
                        </Button> */}
                    </DialogActions>
                </Dialog>

            </Box>
        );
    }
}
 
export default FuBlastReminderTeleSetting;